import LoLContinueButton from './LoLContinueButton';

export default LoLContinueButton;
